import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { SignInPage } from "src/pages/SignInPage";

const PLACEHOLDER_ORIGIN = "https://app.invalid";

const routeSearchSchema = z.object({
  email: z.string().optional(),
  redirect: z.string().refine(isAppPath).optional(),
});

export const Route = createFileRoute("/_public/sign-in")({
  component: RouteComponent,
  ssr: true,
  validateSearch: routeSearchSchema,
});

function RouteComponent() {
  return <SignInPage />;
}

function isAppPath(path: string): boolean {
  return new URL(path, PLACEHOLDER_ORIGIN).origin === PLACEHOLDER_ORIGIN;
}
